import {
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { ModalService } from 'src/app/common/services/modal/modal.service';
import { EditorChoice } from 'src/app/modules/shared/models/editor.choice';
import { VisitorEvent } from 'src/app/modules/shared/models/visitor.event';
import { ActivatedRoute } from '@angular/router';
import { VisitorCardBaseComponent } from '../visitor.card.base.component';

@Component({
  selector: 'ig-visitor-vertical-card',
  templateUrl: './visitor.vertical.card.component.html',
  styleUrls: ['./visitor.vertical.card.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class VisitorVerticalCardComponent extends VisitorCardBaseComponent {
  @Input() override item: VisitorEvent;
  @Input() editorChoiceText: EditorChoice;

  // for other upcoming events
  @Input() override allItems: VisitorEvent[] = [];
  @Output() public onClick = new EventEmitter<any>();

  @HostBinding('class') hostClass = 'ig-vertical-card';

  constructor(
    public override activatedRoute: ActivatedRoute,
    public override modalService: ModalService
  ) {
    super(activatedRoute, modalService);
  }
}
